import { gql } from '@apollo/client'

export default gql(`
query batchGetAssetCategories($input: [ID]) {
    batchGetAssetCategories(input: $input) {
      id
      name
    }
}`)
